import { FC, lazy, Suspense } from 'react';
import { Box } from '../../Box';
import type { AsyncPickerProps } from './type';

const DatePicker = lazy(() => import('./DatePicker'));

export const AsyncDatePicker: FC<AsyncPickerProps> = (props) => {
  const { slotProps } = props;

  return (
    <Suspense
      fallback={
        <Box
          style={{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            ...(slotProps?.textField?.sx['& .MuiInputBase-root'] || {}),
            border:
              'var(--b-border-width-xs) solid var(--input_border_color_1)',
            borderRadius:
              'var(--b-border-radius-custom, var(--b-border-radius-xs))',
            width: '100%'
          }}
        />
      }
    >
      <DatePicker {...props} />
    </Suspense>
  );
};
